"use client";
import React from 'react'
import { ImagePath } from '../../assets/ImagePath';


const Groupinfo = ({ selectedContactDetails, userID, avatarUrl }) => {
    return (
        <>
            <div className="bg-[#F8F8FD] rounded-[15px] p-[30px] w-full mt-10">
                {/* <!-- Icon Section --> */}
                <div className="flex justify-center mb-4">
                    <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center">
                        <img loading="lazy" src={avatarUrl || ImagePath.people} alt="addPeopleIcon" className="rounded-full" />

                    </div>
                </div>

                <div className="text-center mb-4">
                    <h2 className="text-[14px] font-bold text-primary-blue mb-1">{selectedContactDetails?.channelName}</h2>
                    <p className="text-[14px] text-primary-blue">Created by
                        {selectedContactDetails?.channelOwner?.userId === userID ? " you" :
                            selectedContactDetails?.channelOwner?.userName
                        } 
                        {/* on 10/9/2023 */}
                        </p>
                </div>

                <div className="text-center mb-6 max-w-[515px] mx-auto">
                    <p className="text-[14px] text-primary-blue leading-relaxed">
                        {selectedContactDetails?.description}
                    </p>
                </div>

                <div className="text-center">
                    <p className="text-[14px] text-primary-blue font-bold">{selectedContactDetails?.participants?.length} Members</p>
                </div>
            </div>
        </>
    )
}

export default Groupinfo
